import React from 'react'
import {connect} from 'react-redux'
import { Route } from 'react-router'
import QuickResponse from './QuickResponse'

class ClientChatSettings extends React.Component {
    render(){
        return (
            <Route path='/chatSettings/quickResponse' component={QuickResponse}/>
        )
    }
}


export default connect()(ClientChatSettings);



// WEBPACK FOOTER //
// ./src/layout/Dashboard/MainPanel/ChatSettings/index.js